import * as React from "react";
import { IReport3Presenter } from "../../../presenter/report/Report3Presenter";
import { Divider, Typography, Icon } from "antd";
import Report3ParamsBox from "../../components/report/Report3ParamsBox";
import Report3Preview from "../../components/report/Report3Preview";
import Report3PDFExportLink from "../../components/report/Report3PDFExportLink";
export interface Props {}

export interface State extends IReport3Presenter {}

export default class Report3Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      reportingPeriodList,
      onChangeReportingPeriod,
      report3CurrentReportingPeriod,
      translate,
      getPDFReport3,
      report3,
      report3PeriodFrom,
      setPeriodFrom,
      report3PeriodTo,
      setPeriodTo,
      report3Min,
      setMin,
      report3Max,
      setMax,
      report3SubmitReason,
      setSubmitReason,
      getXLSXReport3Link
    } = this.state;

    return (
      <div className={"report-container"}>
        <Report3ParamsBox
          currentReportingPeriod={report3CurrentReportingPeriod}
          reportingPeriodList={reportingPeriodList}
          onChangeReportingPeriod={onChangeReportingPeriod}
          getPDFReport={getPDFReport3}
          translate={translate}
          loading={this.state.loaders.report3Loader}
          onPeriodFromChange={setPeriodFrom}
          onPeriodToChange={setPeriodTo}
          onMinChange={setMin}
          onMaxChange={setMax}
          onSubmitReasonChange={setSubmitReason}
          periodFrom={report3PeriodFrom}
          periodTo={report3PeriodTo}
          min={report3Min}
          max={report3Max}
          submitReason={report3SubmitReason}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report3 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report3Loader && (
                  <Report3PDFExportLink
                    translate={translate}
                    data={report3}
                    title={report3CurrentReportingPeriod?.name}
                    subtitle={translate("reports.report_3")}
                    fileName={`${translate("reports.report_3")}.pdf`}
                  />
                )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                <a
                  key="file-excel"
                  href={getXLSXReport3Link()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon
                    type="file-excel"
                    theme={"outlined"}
                    style={{ fontSize: 20, color: "#20744B" }}
                  />
                </a>
              </div>
            </div>
            <Divider type={"horizontal"} />
            <Report3Preview
              translate={translate}
              data={report3}
              title={report3CurrentReportingPeriod?.name}
              subtitle={translate("reports.report_3")}
            />
          </div>
        )}
      </div>
    );
  }
}
